import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/template/Layout'

import LoginTest from '@/components/inicio/LoginTest'
import UnknowPassword from '@/components/inicio/UnknowPassword'
import ChangePassword from '@/components/inicio/ChangePassword'

import Dge from '@/components/primeraEtapa/Dge'
import DgeCc from '@/components/primeraEtapa/DgeCc'
import Daf from '@/components/primeraEtapa/Daf'
import ListaCentrosMenores from '@/components/primeraEtapa/ListaCentrosMenores'
import ListaVicerrectorias from '@/components/primeraEtapa/ListaVicerrectorias'

import Departamento from '@/components/diagnosticoEstrategico/Departamento'
import EntrevistaExterna from '@/components/diagnosticoEstrategico/EntrevistaExterna'
import EquipoEstrategico from '@/components/diagnosticoEstrategico/EquipoEstrategico'
import Anuncios from '@/components/diagnosticoEstrategico/Anuncios'
import Institucional from '@/components/diagnosticoEstrategico/Institucional'
import Indicador from '@/components/diagnosticoEstrategico/Indicadores.vue'
import IndicadoresRetencion from '@/components/diagnosticoEstrategico/IndicadoresRetencion.vue'
import Analisis from '@/components/diagnosticoEstrategico/AnalisisEncuesta.vue'
import Entorno from '@/components/diagnosticoEstrategico/Entorno'
import Intro from '@/components/diagnosticoEstrategico/Intro'
import Video from '@/components/diagnosticoEstrategico/Video'

import Mision from '@/components/definicionEstrategica/Mision'
import Politicas from '@/components/definicionEstrategica/Politicas'
import Lineas from '@/components/definicionEstrategica/Lineas'
import ODSActual from '@/components/definicionEstrategica/ODSActual'
import ODSFuturo from '@/components/definicionEstrategica/ODSFuturo'
import Tendencias from '@/components/definicionEstrategica/Tendencias'
import Vision from '@/components/definicionEstrategica/Vision'
import IntroDefinicionEstrategica from '@/components/definicionEstrategica/IntroDefinicionEstrategica'

import PriorizacionPolitica from '@/components/planes de desarrollo/PriorizacionPolitica'
import Vicerrectoria from '@/components/planes de desarrollo/Vicerrectoria'
import Plan2021 from '@/components/planes de desarrollo/Planes2021'



import SeguimientoDge from '@/components/implementacion/Seguimiento'
import EstrategiasSeguimiento from '@/components/implementacion/EstrategiasSeguimiento'

import Documentos from '@/components/implementacion/Documentos'
import AnexosC from '@/components/implementacion/AnexosC'
import DocumentosPolitica from '@/components/implementacion/DocumentosPolitica'
import PoliticaDoc from '@/components/implementacion/PoliticaDoc'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: '/loginTest',
      children: [

        {
          path: '/dge',
          name: 'dge',
          component: Dge
        },
        {
          path: '/dgeCc',
          name: 'dgecc',
          component: DgeCc
        },
        {
          path: '/daf',
          name: 'daf',
          component: Daf
        },
        {
          path: '/intro',
          name: 'intro',
          component: Intro
        },
        {
          path: '/intro/equipos',
          name: 'equipos',
          component: EquipoEstrategico
        },

        {
          path: '/intro/anuncios',
          name: 'anuncios',
          component: Anuncios
        },

        {
          path: '/video',
          name: 'video',
          component: Video
        },

        {
          path: '/ccm',
          name: 'ccm',
          component: ListaCentrosMenores
        },

        {
          path: '/vicerrectorias',
          name: 'vicerrectorias',
          component: ListaVicerrectorias
        },

        {
          path: '/planes2021',
          name: 'planes2021',
          component: Plan2021
        },
        {
          path: '/departamento',
          name: 'departamento',
          component: Departamento
        },

        {
          path: '/departamentos/indicadorTitulacion',
          name: 'indicador',
          component: Indicador
        },
        {
          path: '/departamentos/indicadorRetencion',
          name: 'retencion',
          component: IndicadoresRetencion
        },

        {
          path: '/institucional',
          name: 'institucional',
          component: Institucional
        },
        {
          path: '/institucional/analisis',
          name: 'analisis',
          component: Analisis
        },

        {
          path: '/entorno',
          name: 'entorno',
          component: Entorno,
        },
        {
          path: '/entorno/entrevista',
          name: 'entrevista',
          component: EntrevistaExterna,
        },

        {
          path: 'definicionEstrategica/mision',
          name: 'mision',
          component: Mision,
        },

        {
          path: 'definicionEstrategica/intro',
          name: 'introDefinicion',
          component: IntroDefinicionEstrategica,
        },
        {
          path: 'definicionEstrategica/politicas',
          name: 'politicas',
          component: Politicas,
        },
        {
          path: 'definicionEstrategica/lineas',
          name: 'lineas',
          component: Lineas,
        },
        {
          path: 'definicionEstrategica/ODSActual',
          name: 'odsActual',
          component: ODSActual,
        },
        {
          path: 'definicionEstrategica/ODSFuturo',
          name: 'odsFuturo',
          component: ODSFuturo,
        },
        {
          path: 'definicionEstrategica/tendencias',
          name: 'tendencias',
          component: Tendencias,
        },
        {
          path: 'definicionEstrategica/vision',
          name: 'vision',
          component: Vision,
        }
        ,
        {
          path: 'planesDesarrollo/planes/:id',
          name: 'planes',
          component: PriorizacionPolitica,
        },
        {
          path: 'planesDesarrollo/taller',
          name: 'taller',
          component: Vicerrectoria,
        },

        {
          path: 'seguimiento/:id',
          name: 'seguimiento',
          component: SeguimientoDge,
        },

        {
          path: 'estrategias/:id',
          name: 'estrategias',
          component: EstrategiasSeguimiento,
        },
        {
          path: '/documentos/:id',
          name: 'documentos',
          component: Documentos,
          redirect: { name: 'basicos' },
          children: [
            {
              path: 'basicos',
              name: 'basicos',
              component: AnexosC
            },
            {
              path: 'politica/:idEje',
              name: 'politica',
              component: PoliticaDoc
            },
          ]
        },

        {
          path: '/documentosEstrategia/:id',
          name: 'documentosEstrategia',
          component: DocumentosPolitica,
          redirect: { name: 'politica' },
          children: [

            {
              path: 'politica',
              name: 'politica',
              component: PoliticaDoc
            },
          ]
        }
      ]
    },

    {
      path: '/login/changePass',
      name: 'changePass',
      component: ChangePassword
    },

    {
      path: '/loginTest',
      name: 'loginTest',
      component: LoginTest
    }

    ,

    {
      path: '/unknowPassword',
      name: 'unknowPassword',
      component: UnknowPassword
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js